import React, {useState, useEffect} from 'react'
import Placeholder from '../../../src/components/Placeholder'
import {RuleBuilderLayout} from '../../../src/experimental'

const StyledRuleBuilderLayoutExample = () => {
  const [domLoaded, setDomLoaded] = useState(false)
  useEffect(() => {
    setDomLoaded(true)
  }, [])

  return (
    <>
      {domLoaded && (
        <RuleBuilderLayout>
          <RuleBuilderLayout.Header>
            <Placeholder height={'84px'} label={`Header`} />
          </RuleBuilderLayout.Header>
          <RuleBuilderLayout.LeftPane>
            <Placeholder height={'588px'} label={`Left pane`} />
          </RuleBuilderLayout.LeftPane>
          <RuleBuilderLayout.RightPane>
            <Placeholder height={'588px'} label={`Right pane`} />
          </RuleBuilderLayout.RightPane>
          <RuleBuilderLayout.Footer>
            <Placeholder height={'84px'} label={`Footer`} />
          </RuleBuilderLayout.Footer>
        </RuleBuilderLayout>
      )}
    </>
  )
}
export default StyledRuleBuilderLayoutExample
